import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getProductContent,
    ProductDataPointParams,
    ProductDataPointResultModel,
} from "@tSurya/Services/ProductDataPointService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ProductDataPointParams, string>;

export const DispatchBeginUnApprovedCustomerDetails: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductDetails/BeginLoadContent",
        params: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductContent(props.apiParameter);
    } catch (error) {
        // API failure should not block the PDP from rendering
    }
};

export const DispatchCompleteUnApprovedCustomerDetails: HandlerType = props => {
    if (!props.apiResult) {
        props.dispatch({
            type: "Pages/ProductDetails/FailedLoadContent",
        });
        return;
    }
    props.dispatch({
        type: "Pages/ProductDetails/CompleteLoadContent",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginUnApprovedCustomerDetails,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteUnApprovedCustomerDetails,
];

const loadProductDataPoint = createHandlerChainRunner(chain, "loadProductDataPoint");
export default loadProductDataPoint;
